import apiService from './api/api.service';

class CareerReportService {
  /**
   * Get all reports for logged-in user
   */
  async getAllReports() {
    try {
      const response = await apiService.get('/career-reports');
      return response.data.data;
    } catch (error) {
      console.error('Get all reports error:', error);
      throw error;
    }
  }

  /**
   * Get active report
   */
  async getActiveReport() {
    try {
      const response = await apiService.get('/career-reports/active');
      return response.data.data;
    } catch (error) {
      console.error('Get active report error:', error);
      throw error;
    }
  }

  /**
   * Get single report by ID
   */
  async getReportById(id) {
    try {
      const response = await apiService.get(`/career-reports/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Get report by ID error:', error);
      throw error;
    }
  }

  /**
   * Create new report
   */
  async createReport(data = {}) {
    try {
      const response = await apiService.post('/career-reports', data);
      return response.data.data;
    } catch (error) {
      console.error('Create report error:', error);
      // Enhance error object with response details for better error handling
      const enhancedError = new Error(error.message || 'Failed to create report');
      enhancedError.response = { status: error.status, data: error.data };
      enhancedError.originalError = error;
      throw enhancedError;
    }
  }

  /**
   * Update report
   */
  async updateReport(id, data) {
    try {
      const response = await apiService.put(`/career-reports/${id}`, data);
      return response.data.data;
    } catch (error) {
      console.error('Update report error:', error);
      throw error;
    }
  }

  /**
   * Update report data (auto-save)
   */
  async updateReportData(id, data, completionInfo = null) {
    try {
      const payload = { data };
      if (completionInfo) {
        payload.completedSteps = completionInfo.completed;
        payload.totalSteps = completionInfo.total;
        payload.status = completionInfo.completed === completionInfo.total ? 'completed' : 'in_progress';
      }
      
      const response = await apiService.patch(`/career-reports/${id}/data`, payload);
      return response.data.data;
    } catch (error) {
      console.error('Update report data error:', error);
      throw error;
    }
  }

  /**
   * Set active report
   */
  async setActiveReport(id) {
    try {
      const response = await apiService.put(`/career-reports/${id}/set-active`);
      return response.data.data;
    } catch (error) {
      console.error('Set active report error:', error);
      throw error;
    }
  }

  /**
   * Rename report
   */
  async renameReport(id, reportName) {
    try {
      const response = await apiService.put(`/career-reports/${id}/rename`, { reportName });
      return response.data.data;
    } catch (error) {
      console.error('Rename report error:', error);
      throw error;
    }
  }

  /**
   * Delete report
   */
  async deleteReport(id) {
    try {
      const response = await apiService.delete(`/career-reports/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Delete report error:', error);
      throw error;
    }
  }
}

export default new CareerReportService();
